import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client } from '../../../api/api-reference';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../../services/auth.service';
import { jwtDecode } from 'jwt-decode';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [AngularSvgIconModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private client: Client,
    private toastr: ToastrService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }

  login(retryCount: number = 2): void {
    if (environment.useOpenIddict) {
      this.client.identityLogin().subscribe({
        next: (response) => {
          if (typeof response === 'string') {
            this.document.location.href = response;
          }

          //STAGING/PROD ENV
        },
        error: (err) => {
          this.authService.logout();

          if (retryCount > 0) {
            this.login(retryCount - 1);
          } else {
            console.error('Login failed after 2 retries:', err);
          }
        },
      });
    } else {
      const userInput = window.prompt('Please enter your e-mail:', '');
      if (userInput !== null && userInput.trim() !== '') {
        this.client.getToken(userInput).subscribe({
          next: (result) => {
            localStorage.setItem('token', result);
            localStorage.setItem('tz', (jwtDecode(result) as { timeZone: string }).timeZone)
            window.location.reload();
          },
          error: (err) => {
            this.toastr.warning(err);
          },
        });
      } else {
        console.log('Unauthorized!.');
      }
    }
  }
}
